import { dcolors, dlog, TObject } from "corexxx";
import { useDAppCommand } from "../../libs/dweb/DAppCommand"
import { DButton } from "../../libs/dweb/DButton";
import { DCol } from "../../libs/dweb/DCol";
import { DBox } from "../../libs/dweb/DBox";
import { DRow } from "../../libs/dweb/DRow";
import { DDialogSimple } from "../../libs/dweb/DDialogSimple";
import { DText } from "../../libs/dweb/DText";
import { convertEpochTo2HrFormat, getLastTradingDay, convertToQuote, getFormattedDate, calculateNetDelta } from "./helper"
import { DHook } from "../../libs/common_hooks/DHook";
import { DTable } from "../../libs/dweb/DTable";
import { DAlert } from "../../libs/dweb/DAlert";
import { LineChart, CartesianGrid, XAxis, YAxis, Legend, Line, Tooltip, ResponsiveContainer, Text, Label, ReferenceLine } from "recharts";
import React, { useState } from "react";
import { DRefreshButton } from "../../libs/dweb/DRefreshButton";
import { DSelectInput } from "../../libs/dweb/DSelectInput";
const SECTORS = "XLU,XLP,XLV,XLK,XLE,XLF,XLB,XLI,XLY,XLT,VNQ"; // Top 10 SPX stocks
const SECTOR_DESCRIPTIONS: TObject = {
  "XLU": "Utilities.",
  "XLP": "ConsumerStaples",
  "XLV": "Healthcare",
  "XLK": "Technology",
  "XLE": "Energy",
  "XLF": "Financials",
  "XLB": "Materials",
  "XLI": "Industrials",
  "XLY": "ConsumerDisc",
  "XLT": "Telecomm",
  "VNQ": "RealEstate"
};
export function AdvanceAnalysisView() {
  let appCommand = useDAppCommand();
  let [setting, setSetting] = useState(false)
  let [frequency, setFrequency] = useState("1")
  let [netDelta, setNetDelta] = React.useState([])
  let account = DHook.useNetwork(`${appCommand.state.simpleStoreEndpoint}/api/utils/schwab/get_all_data?auth_token_=${appCommand.accountState?.auth_token_}`)
  let stock = DHook.useNetwork(`${appCommand.state.simpleStoreEndpoint}/api/utils/schwab/quote?auth_token_=${appCommand.accountState?.auth_token_}&symbols=AAPL,MSFT,NVDA,AMZN,META,GOOGL,TSLA,AVGO,NFLX,$VIX,$SPX`)
  let sector = DHook.useNetwork(`${appCommand.state.simpleStoreEndpoint}/api/utils/schwab/quote?auth_token_=${appCommand.accountState?.auth_token_}&symbols=${SECTORS}`)
  let spxChain = DHook.useNetwork(`${appCommand.state.simpleStoreEndpoint}/api/utils/schwab/chains?auth_token_=${appCommand.accountState?.auth_token_}&symbol=$SPX`)
  let spxHistory = DHook.useNetwork(`${appCommand.state.simpleStoreEndpoint}/api/utils/schwab/pricehistory?auth_token_=${appCommand.accountState?.auth_token_}&symbol=$SPX&date=${getLastTradingDay()}&frequency=${frequency}`)
  let vixHistory = DHook.useNetwork(`${appCommand.state.simpleStoreEndpoint}/api/utils/schwab/pricehistory?auth_token_=${appCommand.accountState?.auth_token_}&symbol=$VIX&date=${getLastTradingDay()}&frequency=${frequency}`)
  let netDeltaResp = DHook.useNetwork(`${appCommand.state.simpleStoreEndpoint}/api/utils/schwab/net_delta?cmd=result`)

  React.useEffect(() => {
    let data = netDeltaResp.state.data?.out.map((y: any) => {
      let d = new Date(y.time)
      return { time: d.toTimeString().slice(0, 5), price: y.result.netDelta }
    })
    setNetDelta(data || [])
  }, [netDeltaResp])

  return (
    <>
      {account.state.data?.status == "error" ? (<DAlert
        style={{ maxWidth: 800, margin: '0 auto', marginTop: 30, }}
        notification={{
          type: "error",
          msg: "You are <b>not connected </b>to schwab. Please connect to get the realtime information.",
          is_loading: undefined
        }}
        actionJsx={
          <DButton
            style={{ flex: 1 }}
            href="https://api.schwabapi.com/v1/oauth/authorize?client_id=BfQwxJGANBot1jWGO4e4LUuVjP33ckXs&redirect_uri=https://money.grodok.com/oauth/schwab">Connect to schwab</DButton>
        }
      />) : (
        <DBox
          innerStyle={{ padding: 0 }}
          style={{ padding: 0, background: 'none', boxShadow: 'none' }}>
          <DRow >
            <DCol style={{ background: 'none', flex: 4 }}>
              <DRow center style={{ padding: 0, background: dcolors.pallets.amber100, flex: 0 }}>
                {stock.state.data ? <TopSymbolSummary data={stock.state.data.out["$SPX"]} /> : null}
                <ChainSummary spxChain={spxChain} />
                <DSelectInput
                  value={frequency}
                  style={{ marginLeft: 10, marginRight: 10, }}
                  onChange={setFrequency}
                  options={['1', '5', '15']}
                />
                <DRefreshButton onClick={() => {
                  stock.api.reload();
                  sector.api.reload();
                  spxChain.api.reload()
                  spxHistory.api.reload()
                  vixHistory.api.reload()
                }} />

              </DRow>
              <StockCharts spx={spxHistory} vix={vixHistory} netDelta={netDelta} />
              <BottomTable spxChain={spxChain} />
            </DCol>
            <DCol style={{ flex: 1, width: '250', paddingLeft: 20 }}>
              <DTable
                style={{ marginBottom: 10 }}
                config={{ title: 'Stock' }}
                data={convertToQuote(stock)}
                columns={[
                  { field: 'symbol' },
                  { field: 'ltp' },
                  { field: 'pchange', format: (x) => (x || 0).toFixed(2) + '%', styleFn: (x: number) => ({ color: x > 0 ? 'green' : 'red' }) },
                ]}
              />

              <DTable
                config={{ title: 'Sector' }}
                data={convertToQuote(sector)}
                columns={[
                  { field: 'symbol', format: (x) => SECTOR_DESCRIPTIONS[x] },
                  { field: 'ltp' },
                  { field: 'pchange', format: (x) => (x || 0).toFixed(2) + '%', styleFn: (x: number) => ({ color: x > 0 ? 'green' : 'red' }) },

                ]}
              />
            </DCol>

          </DRow>
          <DRow style={{ flex: 0 }}>
            <DButton text="Start Scheduler" onClick={() => appCommand.api.getSimpleStore('/api/utils/schwab/net_delta?cmd=start')}></DButton>
          </DRow>
        </DBox >
      )}
      <DDialogSimple width={800} dialog_title={"Settings"} onClose={() => setSetting(false)} open={setting}>
        <DCol style={{ padding: 20 }}>
        </DCol>
      </DDialogSimple>
    </>
  );
}

function TopSymbolSummary({ data }: { data: any }) {
  return <>
    <DText style={{ flex: 1 }} html>{` ${data.symbol} 
    <span style="font-weight:bold;font-size:large;color:${data.quote.netChange > 0 ? "green" : "red"}"> 
    ${data.quote.netChange > 0 ? '<span style="color:green">⬆</span>' : '<span style="color:red">⬇</span>'} 
    ${data.quote.lastPrice.toFixed(2)}(${data.quote.netChange > 0 ? '+' : ''}
    ${data.quote.netChange}, ${data.quote.netPercentChange.toFixed(2)}%)
    </span>
    <span style="font-size:12px">on ${getFormattedDate(data.quote.tradeTime)}</span>
        <span style="font-size:12px">P.Close ${(data.quote.lastPrice - data.quote.netChange).toFixed(2)}</span>
    
    `}</DText>
  </>
}


function ChainSummary({ spxChain }: { spxChain: any }) {
  let appCommand = useDAppCommand()
  const [data, setData] = useState<string>(''); // Historical SPX price data
  let resp = spxChain;
  React.useEffect(() => {
    if (resp.state.data?.status != "success") {
      return;
    }
    let resp0 = resp.state.data.out as any
    let resp1 = calculateNetDelta(resp0) as any
    setData(`Net Delta: <span style="color:green;font-weight:bold">${resp1.netDelta}</span> ✫
       Total Call Vol: <span style="color:green;font-weight:bold">${resp1.totalCallVolume}</span> ✫
       Total put Vol: <span style="color:green;font-weight:bold">${resp1.totalPutVolume}</span> ✫
       Put/Call: <span style="color:green;font-weight:bold">${resp1.ratio}</span>
       `)
  }, [resp.state.data])
  return <DText html>{data}</DText>
}

function BottomTable({ spxChain }: { spxChain: any }) {
  let appCommand = useDAppCommand()
  const [data, setData] = useState<any>(null); // Historical SPX price data
  let resp = spxChain
  React.useEffect(() => {
    if (resp.state.data?.status != "success") {
      return;
    }
    let resp0 = resp.state.data.out as any
    setData(calculateNetDelta(resp0) as any)
  }, [resp.state.data])
  return data ? <DRow>
    <DTable
      config={{ title: 'Top 5 Call' }}
      data={data.topCalls}
      style={{ width: 'auto', marginRight: 10, flex: 1 }}
      columns={[
        { field: 'strikePrice' },
        { field: 'totalVolume' },
        { field: 'gamma' },
        { field: 'delta' }
      ]} />
    <DTable
      config={{ title: 'Top 5 Put' }}
      style={{ width: 'auto', marginRight: 10, flex: 1 }}
      data={data.topPuts}

      columns={[
        { field: 'strikePrice' },
        { field: 'totalVolume' },
        { field: 'gamma' },
        { field: 'delta' }
      ]} />
    <DTable
      config={{ title: 'highGammaCalls' }}
      style={{ width: 'auto', marginRight: 10, flex: 1 }}
      data={data.highGammaCalls}
      columns={[
        { field: 'strikePrice' },
        { field: 'totalVolume' },
        { field: 'gamma' },
        { field: 'delta' },
      ]} />
    <DTable
      config={{ title: 'highGammaPuts' }}
      data={data.highGammaPuts}
      style={{ width: 'auto', flex: 1 }}
      columns={[
        { field: 'strikePrice' },
        { field: 'totalVolume' },
        { field: 'gamma' },
        { field: 'delta' },
      ]} />

  </DRow> : null
}


function SymbolChart({ symbol, cursorIndex, onMouseMove, data }: { symbol: string, cursorIndex?: any, onMouseMove: any, data: any }) {
  let appCommand = useDAppCommand()
  const [priceData, setPriceData] = useState<any[]>(data); // Historical SPX price data
  const [lastData, setLastData] = useState(6100);
  React.useEffect(() => {
    setPriceData(mergeTradingData(generateTradingTimes(), data || []))
    // setPriceData(data)
  }, [data])

  return (<DCol style={{ height: 200, flex: 0 }}>
    <ResponsiveContainer width="100%" height={200}>
      <LineChart data={priceData} onMouseMove={onMouseMove}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" />
        <YAxis domain={["auto", "auto"]} />
        <YAxis>
          {/* Add a custom label to the Y-axis */}
          <Label value="Price" angle={-90} position="left" style={{ fontSize: 16, fontWeight: "bold" }} />
        </YAxis>
        <Tooltip
        />
        <Legend
          verticalAlign="top"
          align="right"
          iconType="circle"
          iconSize={10}
          formatter={(value) => (
            <span style={{ color: "#8884d8", fontSize: 14 }}>
              {symbol}: {value} - Stock Price (USD)
            </span>
          )}
        />
        <Line type="monotone" dataKey="price" stroke="#8884d8" activeDot={{ r: 8 }} dot={false} connectNulls={true} />
        {lastData > 0 ?
          <ReferenceLine y={lastData} stroke="red" strokeDasharray="1 1" label="Previous Close" /> : null}
      </LineChart>
    </ResponsiveContainer>
  </DCol>)
}

function generateTradingTimes(): { time: string; price: number | null }[] {
  const times: { time: string; price: number | null }[] = [];

  let startHour = 14, startMinute = 30;
  let endHour = 21, endMinute = 0;
  let interval = 1;

  let currentDate = new Date();
  currentDate.setHours(startHour, startMinute, 0, 0);

  let endDate = new Date();
  endDate.setHours(endHour, endMinute, 0, 0);

  while (currentDate <= endDate) {
    const hh = String(currentDate.getHours()).padStart(2, '0');
    const mm = String(currentDate.getMinutes()).padStart(2, '0');
    times.push({ time: `${hh}:${mm}`, price: null });
    currentDate.setMinutes(currentDate.getMinutes() + interval);
  }
  return times;
}


function mergeTradingData(baseData: { time: string; price: number | null }[], overrideData: { time: string; price: number | null }[]): { time: string; price: number | null }[] {
  const overrideMap = new Map(overrideData.map(entry => [entry.time, entry.price]));

  return baseData.map(entry => ({
    time: entry.time,
    price: overrideMap.has(entry.time) ? overrideMap.get(entry.time)! : entry.price
  }));
}


const StockCharts = ({ spx, vix, netDelta }: { spx: any, vix: any, netDelta: any }) => {
  const [cursorIndex, setCursorIndex] = useState<number>(10);

  const handleMouseMove = (e: any) => {
    if (e.activeCoordinate) {
      const mouseX = e.activeCoordinate.x; // Active X-coordinate
      const index = Math.floor((mouseX / e.chartX) * 500); // Calculate index based on the X-coordinate
      setCursorIndex(index);
    }
  };
  dlog.d(">>>>" + (spx.state.data?.out.candles || []).length)
  return <>
    <SymbolChart
      symbol="$SPX"
      cursorIndex={cursorIndex}
      onMouseMove={handleMouseMove}
      data={spx.state.data?.out.candles?.map((x: any) => ({ time: convertEpochTo2HrFormat(x.datetime), price: x.close }))}
    />

    <SymbolChart
      symbol="$VIX"
      cursorIndex={cursorIndex}
      onMouseMove={handleMouseMove}
      data={vix.state.data?.out.candles?.map((x: any) => ({ time: convertEpochTo2HrFormat(x.datetime), price: x.close }))}
    />
    <SymbolChart symbol="NetDelta" cursorIndex={cursorIndex} onMouseMove={handleMouseMove} data={netDelta} />
  </>
}